// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8fff63d0","160":"0348d9f5","208":"59086383","293":"85941eef","453":"2741d6c9","516":"1e378137","519":"c7680f4d","906":"2f7163f6","917":"d807da34","946":"ad4147c3"}[chunkId] + ".chunk.js";
};